var map = {
	"./de/de_main.json": 1422,
	"./de/de_mb.json": 89,
	"./el/el_main.json": 7863,
	"./el/el_mb.json": 1616,
	"./en/en_main.json": 6690,
	"./en/en_mb.json": 1645,
	"./es/es_main.json": 7389,
	"./es/es_mb.json": 5450,
	"./fr/fr_main.json": 4689,
	"./fr/fr_mb.json": 2004,
	"./zh/zh_main.json": 6509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3595;